import { createBrowserRouter, redirect } from "react-router-dom";

import CompanyRegisterPage from "../pages/CompanyRegisterPage";
import PasswordRegisterPage from "../pages/PasswordRegisterPage";
import UserRegisterPage from "../pages/UserRegisterPage";
import PasswordRecoveryPage from "../pages/PasswordRecoveryPage";
import NotFoundPage from "../pages/NotFoundPage";
import SuccessPage from "../pages/SuccessPage";
import ThanksPage from "../pages/ThanksPage";
import ChargePage from "../pages/ChargePage";
import EmailConfirmation from "../pages/EmailConfirmation";

export default createBrowserRouter([
  {
    path: "/company",
    element: <CompanyRegisterPage />
  },
  {
    path: "/charge",
    element: <ChargePage />
  },
  {
    path: "/success",
    element: <SuccessPage />
  },
  {
    path: "/thanks",
    element: <ThanksPage />
  },
  {
    path: "/password/recovery",
    element: <PasswordRecoveryPage />
  },
  {
    path: "/email-confirmation",
    element: <EmailConfirmation />
  },
  {
    path: "/password",
    element: <PasswordRegisterPage />
  },
  {
    path: "/user",
    element: <UserRegisterPage />
  },
  {
    path: "/",
    loader: () => redirect("/company"),
    errorElement: <NotFoundPage />
  }
]);
